import * as React from "react";
import { useTranslation } from "react-i18next";
import { Label } from "components/bootstrap";
const DataLakeBackendState = ({ isActiveBackend }) => {
  const { t } = useTranslation("enterprise_data_lake");
  if (!isActiveBackend) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Label, { bsStyle: "success", bsSize: "xsmall" }, t("backend_state.active"));
};
export default DataLakeBackendState;
